import styled from "styled-components";

export const ButtonIcon = styled.button<{ $cursor: boolean }>`
  border: none;
  background-color: transparent;
  width: auto;
  padding: 0px;
  cursor: ${props => (props.$cursor ? "pointer" : "normal")};
`;
